import ButtonSort from '../../../../shared/ButtonSort';
import PermissionCell from '../../hooks/Cell/PermissionCell';
import Style from '../../hooks/Cell/Style';
import Content from './Content';

const Cell = ({ permissions = [], actionName, isEditor, permissionsRoles = [], setPermissionsSave}) => {
  const cell = PermissionCell({ permissions, permissionsRoles, setPermissionsSave });
  const vm = Style({ size: cell.permissions.length });
  const { IsEmpty, IsSingle, IsMultiple } = Content({updateCheck: cell.updateCheck, isEditor});
  const forceMenu = String(actionName || '').toLowerCase() === 'especial';

  if (cell.isEmpty) return <IsEmpty />

  if (cell.isSingle && !forceMenu)
    return <IsSingle permission={cell.permissions[0]} />

  return (
    <>
      <div className="flex h-full w-full items-center justify-center">
        <div ref={vm.buttonRef}>
          <ButtonSort
            handleSort={vm.handleMenu}
            direction={vm.open ? 'asc' : 'desc'}
            className="text-personalized"
          />
        </div>
      </div>
      {vm.open && (
        <div
          ref={vm.menuRef}
          className="fixed z-[9999] w-[240px] rounded-md border border-gray-200 bg-white shadow-xl"
          style={{
            top: `${vm.menuPosition.top}px`,
            left: `${vm.menuPosition.left}px`,
          }}
        >
          <div className="max-h-48 overflow-y-auto py-1">
            {cell.permissions.map((permission) => (
              <IsMultiple key={permission.Id} permission={permission} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Cell;
